import React from "react";
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import TopFeatureBlock from './features/elements/TopFeatureBlock';
import Slider from '../containers/elements/Slider';
import CapsuleBlock from './features/CapsuleBlock';
import SoundLibrariesBlock from './features/SoundLibrariesBlock';
import StraightToSoundBlock from './features/StraightToSoundBlock';
import CapsulePortalBlock from './features/CapsulePortalBlock';
import PricingBlock from './features/PricingBlock';
import CenteredContentWrapper from './elements/CenteredContentWrapper';
import VideoOverlay from '../containers/elements/VideoOverlay';
import Header from '../containers/Header';
import Footer from '../containers/Footer';
import {slides, startSlideIndex} from '../config/slider';
import { heroSectionMode } from '../config/app';
import { taglineText } from '../config/texts';
import * as heroSectionModes from '../constants/heroSectionModes';
import Testimonials from './features/Testimonials';
import TopVideoBlock from './features/TopVideoBlock';
import {pageFeatures, preload} from '../helpers/images';
import {titles} from "../config/routes";
import PurpleButton from "./elements/form/button/PurpleButton";
import {getStartedButton} from "../constants/classes/features";
import {getLandingSubscriptionButtonLink} from "../helpers/subscription";
import AmazingSound from "./landing/AmazingSound";
import SuperCharged from "./landing/SuperCharged";
import VideoSlides from "../containers/elements/VideoSlides";
import { videoBlocksData } from '../config/landing';
import {isMobile} from "../config/ui";

class Features extends React.PureComponent {
    state = {
        elementBounds: {},
    };

    static getDerivedStateFromProps(props, state) {
        if (props.isVideoIntroComplete) {
            setTimeout(() => {
                document.body.style.overflow = "auto";
            }, 2000);
        }

        return null;
    }
    componentDidMount() {
        let { isVideoIntro, registerPageView } = this.props;

        /*if (isVideoIntro) {
            document.body.style.overflow = "hidden";
        }*/

        // preload logo images
        preload(pageFeatures);

        registerPageView(titles.features);
    }

    getStartedClickHandler = () => {
        const { history, subscriptionState } = this.props;

        return history.push(getLandingSubscriptionButtonLink(subscriptionState));
    }

    getVideoSlides = () => {
        return videoBlocksData;
    }
    render() {
        let {
            checkout,
            isUserVerified,
            isSubscriptionActive,
            customerPortal,
            isCustomerPortalPending,
            isPaymentResultPending,
            focusVerificationPopup,
            isLogged,
            isHeroVideoPlaying,
            isVideoIntro,
            videoIntroComplete,
            isVideoIntroComplete,
            monthPlan,
            isPurchaseAvailable,
            subscriptionState,
        } = this.props;

        const pageClass = heroSectionMode === heroSectionModes.MODE_IMAGE ? 'hero-image' : 'hero-video';
        const containerClass = heroSectionMode === heroSectionModes.MODE_IMAGE ? 'hero-image-container' : 'hero-video-container';

        return (
            <div className={`features page ${pageClass}` + (isHeroVideoPlaying ? ' video-playing' : '')}>
                <Header heroSectionMode={heroSectionMode} className={'features'} isVideoIntro={isVideoIntro} isVideoIntroComplete={isVideoIntroComplete}/>

                <VideoOverlay/>

                {heroSectionMode === heroSectionModes.MODE_IMAGE ? <CenteredContentWrapper className={`hero-section ${containerClass}`}>
                    <TopFeatureBlock
                        monthPlan={monthPlan}
                        title={taglineText}
                        text={'Unlock Capsule, a simple yet powerful instrument plugin, endlessly updated with fresh sounds, themes, and ideas.'}
                        className={'top-feature'}
                    />
                </CenteredContentWrapper> :
                    <TopVideoBlock
                        videoSrc={isMobile ? require('../assets/video/header_video_mobile version_01.mp4') : require('../assets/video/hero-background-optimized-no-sound-compressed-4-cut.mp4')}
                        isVideoIntro={isVideoIntro}
                        videoIntroComplete={videoIntroComplete}
                        isVideoIntroComplete={isVideoIntroComplete}>
                        <div className={'info'}>
                            <div className={'title'}>
                                {taglineText}
                            </div>
                            <div className={'sub-title'}>
                                Unlock Capsule, a simple yet powerful instrument plugin, endlessly updated with fresh sounds, themes, and ideas.
                            </div>

                            <div>
                                <PurpleButton className={getStartedButton} isLoading={isPaymentResultPending} onClick={this.getStartedClickHandler}>Get started</PurpleButton>
                            </div>
                            <div className={'trial-info'}>
                                {monthPlan.trial_duration}-day free trial then ${monthPlan.price} monthly
                            </div>
                        </div>
                    </TopVideoBlock>}

                <CapsuleBlock/>

                <Slider
                    slides={slides}
                    slideIndex={startSlideIndex}
                />

                <AmazingSound/>

                <SoundLibrariesBlock/>

                <StraightToSoundBlock/>

                <SuperCharged/>

                <VideoSlides
                    title={'See why it’s the real deal'}
                    columns={3}
                    videoSlides={this.getVideoSlides()}
                />

                <CapsulePortalBlock/>

                <Testimonials/>

                <PricingBlock
                    subscriptionState={subscriptionState}
                    monthPlan={monthPlan}
                    //setBounds={this.setElementBounds}
                    isLogged={isLogged}
                    focusVerificationPopup={focusVerificationPopup}
                    isPaymentResultPending={isPaymentResultPending}
                    isCustomerPortalPending={isCustomerPortalPending}
                    customerPortal={customerPortal}
                    isUserVerified={isUserVerified}
                    isSubscriptionActive={isSubscriptionActive}
                    isPurchaseAvailable={isPurchaseAvailable}
                    checkout={checkout}/>

                <Footer/>
            </div>
        );
    }
}

Features.propTypes = {
    //slideIndex: PropTypes.number.isRequired,
    isHeroVideoPlaying: PropTypes.bool.isRequired,
    isVideoIntroComplete: PropTypes.bool.isRequired,
    isPurchaseAvailable: PropTypes.bool.isRequired,
    toggleVideoSound: PropTypes.func.isRequired,
    playVideo: PropTypes.func.isRequired,
    checkout: PropTypes.func.isRequired,
    customerPortal: PropTypes.func.isRequired,
    registerPageView: PropTypes.func.isRequired,
    focusVerificationPopup: PropTypes.func.isRequired,
    isVideoSound: PropTypes.bool.isRequired,
    isUserVerified: PropTypes.bool.isRequired,
    isSubscriptionActive: PropTypes.bool.isRequired,
    isCustomerPortalPending: PropTypes.bool.isRequired,
    isPaymentResultPending: PropTypes.bool.isRequired,
    isVideoIntro: PropTypes.bool.isRequired,
    monthPlan: PropTypes.object,
    subscriptionState: PropTypes.string,
};

export default withRouter(Features);
